var map = {
	"./blockchains/bitcoin cash.svg": "c6be",
	"./blockchains/bitcoin.svg": "7b2e",
	"./blockchains/bnb smart chain.svg": "7f0e",
	"./blockchains/cardano.svg": "e353",
	"./blockchains/dash.svg": "682c",
	"./blockchains/eos.svg": "843b",
	"./blockchains/ethereum classic.svg": "c9c3",
	"./blockchains/ethereum.svg": "88ab",
	"./blockchains/faster payments.svg": "47b2",
	"./blockchains/litecoin.svg": "be9f",
	"./blockchains/polygon.svg": "7319",
	"./blockchains/ripple.svg": "b703",
	"./blockchains/sepa.svg": "9e36",
	"./blockchains/stellar.svg": "41be",
	"./blockchains/swift.svg": "cf9d",
	"./blockchains/tezos.svg": "99c5",
	"./blockchains/tron.svg": "1264",
	"./blockchains/zcash.svg": "87ee",
	"./cryptoicons/$pac.svg": "73ce",
	"./cryptoicons/0x0.svg": "f6c0",
	"./cryptoicons/0xbtc.svg": "c654",
	"./cryptoicons/1000sats.svg": "1eeb",
	"./cryptoicons/1inch.svg": "7892",
	"./cryptoicons/1inchdown.svg": "5d74",
	"./cryptoicons/1inchup.svg": "d988",
	"./cryptoicons/2give.svg": "0d29",
	"./cryptoicons/aave.svg": "5214",
	"./cryptoicons/aavedown.svg": "cd0a",
	"./cryptoicons/aaveup.svg": "60b9",
	"./cryptoicons/abbc.svg": "606e",
	"./cryptoicons/abt.svg": "2d48",
	"./cryptoicons/aca.svg": "dd5a",
	"./cryptoicons/ach.svg": "a291",
	"./cryptoicons/acm.svg": "f4ad",
	"./cryptoicons/acs.svg": "d73f",
	"./cryptoicons/act.svg": "07ae",
	"./cryptoicons/actn.svg": "cac8",
	"./cryptoicons/acx.svg": "ac28",
	"./cryptoicons/ada.svg": "41c8",
	"./cryptoicons/adadown.svg": "4da9",
	"./cryptoicons/adaup.svg": "b2b9",
	"./cryptoicons/add.svg": "85ae",
	"./cryptoicons/adx.svg": "7bb2",
	"./cryptoicons/adxold.svg": "0af1",
	"./cryptoicons/ae.svg": "7a66",
	"./cryptoicons/aed.svg": "0739",
	"./cryptoicons/aeon.svg": "3cf3",
	"./cryptoicons/aergo.svg": "1a58",
	"./cryptoicons/aeur.svg": "2db8",
	"./cryptoicons/afn.svg": "ab04",
	"./cryptoicons/agi.svg": "9bd0",
	"./cryptoicons/agix.svg": "388b",
	"./cryptoicons/agla.svg": "9cd8",
	"./cryptoicons/agld.svg": "df5d",
	"./cryptoicons/agrs.svg": "80f3",
	"./cryptoicons/aht.svg": "8649",
	"./cryptoicons/aion.svg": "79d7",
	"./cryptoicons/aioz.svg": "00cc",
	"./cryptoicons/akita.svg": "cc90",
	"./cryptoicons/akro.svg": "fcfd",
	"./cryptoicons/akt.svg": "59cf",
	"./cryptoicons/alcx.svg": "de5e",
	"./cryptoicons/aleph.svg": "5298",
	"./cryptoicons/alex.svg": "0928",
	"./cryptoicons/algo.svg": "e0ed",
	"./cryptoicons/ali.svg": "726e",
	"./cryptoicons/alice.svg": "d0c4",
	"./cryptoicons/alpaca.svg": "67c0",
	"./cryptoicons/alph.svg": "95e1",
	"./cryptoicons/alpha.svg": "039f",
	"./cryptoicons/alpine.svg": "29cf",
	"./cryptoicons/alt.svg": "166d",
	"./cryptoicons/alu.svg": "c627",
	"./cryptoicons/amb.svg": "c8df",
	"./cryptoicons/amd.svg": "89a7",
	"./cryptoicons/amp.svg": "1187",
	"./cryptoicons/ampl.svg": "2c99",
	"./cryptoicons/anc.svg": "5cee",
	"./cryptoicons/andy.svg": "078f",
	"./cryptoicons/ankr.svg": "5e9c",
	"./cryptoicons/ant.svg": "5e8e",
	"./cryptoicons/antold.svg": "6fe4",
	"./cryptoicons/any.svg": "c3d2",
	"./cryptoicons/ape.svg": "b257",
	"./cryptoicons/apex.svg": "9c9d",
	"./cryptoicons/api3.svg": "cf95",
	"./cryptoicons/apm.svg": "ed62",
	"./cryptoicons/appc.svg": "19d9",
	"./cryptoicons/apt.svg": "204e",
	"./cryptoicons/apx.svg": "c929",
	"./cryptoicons/aqt.svg": "55ab",
	"./cryptoicons/ar.svg": "046e",
	"./cryptoicons/arb.svg": "fe0a",
	"./cryptoicons/ardr.svg": "a3ed",
	"./cryptoicons/arg.svg": "c616",
	"./cryptoicons/ark.svg": "c1c9",
	"./cryptoicons/arkm.svg": "1797",
	"./cryptoicons/arn.svg": "0a71",
	"./cryptoicons/arnx.svg": "ac0a",
	"./cryptoicons/arpa.svg": "da99",
	"./cryptoicons/arrr.svg": "c835",
	"./cryptoicons/ars.svg": "3dc9",
	"./cryptoicons/ary.svg": "78c3",
	"./cryptoicons/asd.svg": "0fc4",
	"./cryptoicons/asm.svg": "c3ec",
	"./cryptoicons/asr.svg": "4576",
	"./cryptoicons/ast.svg": "6c75",
	"./cryptoicons/astr.svg": "759d",
	"./cryptoicons/ata.svg": "a791",
	"./cryptoicons/atd.svg": "bcf2",
	"./cryptoicons/atlas.svg": "3d7b",
	"./cryptoicons/atm.svg": "28d4",
	"./cryptoicons/atom.svg": "69c3",
	"./cryptoicons/ator.svg": "b6a6",
	"./cryptoicons/auction.svg": "eb43",
	"./cryptoicons/aud.svg": "ba53",
	"./cryptoicons/audio.svg": "aa2d",
	"./cryptoicons/audr.svg": "5052",
	"./cryptoicons/aurora.svg": "9cdb",
	"./cryptoicons/aury.svg": "457e",
	"./cryptoicons/auto.svg": "6fbd",
	"./cryptoicons/ava.svg": "9be5",
	"./cryptoicons/avax.svg": "9ebf",
	"./cryptoicons/axl.svg": "1c8c",
	"./cryptoicons/axs.svg": "8e2c",
	"./cryptoicons/axsold.svg": "643b",
	"./cryptoicons/aywa.svg": "8e2e",
	"./cryptoicons/azero.svg": "6451",
	"./cryptoicons/bab.svg": "33af",
	"./cryptoicons/babydoge.svg": "ad59",
	"./cryptoicons/bad.svg": "0f9d",
	"./cryptoicons/badger.svg": "566a",
	"./cryptoicons/bake.svg": "e760",
	"./cryptoicons/bal.svg": "8d75",
	"./cryptoicons/band.svg": "f333",
	"./cryptoicons/bar.svg": "52b1",
	"./cryptoicons/bat.svg": "4821",
	"./cryptoicons/bax.svg": "853f",
	"./cryptoicons/bay.svg": "02f0",
	"./cryptoicons/bbf.svg": "4569",
	"./cryptoicons/bcbc.svg": "5df1",
	"./cryptoicons/bcc.svg": "e58d",
	"./cryptoicons/bcd.svg": "fd32",
	"./cryptoicons/bch.svg": "28fe",
	"./cryptoicons/bcha.svg": "aeda",
	"./cryptoicons/bchdown.svg": "a5e4",
	"./cryptoicons/bchsv.svg": "6b07",
	"./cryptoicons/bchup.svg": "7fde",
	"./cryptoicons/bcio.svg": "5a57",
	"./cryptoicons/bcn.svg": "4e8d",
	"./cryptoicons/bco.svg": "d0a5",
	"./cryptoicons/bcpt.svg": "0242",
	"./cryptoicons/bcx.svg": "3223",
	"./cryptoicons/bdl.svg": "c342",
	"./cryptoicons/bdot.svg": "e1b2",
	"./cryptoicons/bdx.svg": "ad30",
	"./cryptoicons/beam.svg": "0daf",
	"./cryptoicons/bear.svg": "eb03",
	"./cryptoicons/bel.svg": "86c8",
	"./cryptoicons/bela.svg": "a0f8",
	"./cryptoicons/beta.svg": "5f34",
	"./cryptoicons/beth.svg": "79d9",
	"./cryptoicons/bfc.svg": "1569",
	"./cryptoicons/bgb.svg": "fc74",
	"./cryptoicons/bgbp.svg": "ac30",
	"./cryptoicons/bgn.svg": "d25e",
	"./cryptoicons/bhd.svg": "3135",
	"./cryptoicons/bico.svg": "5b25",
	"./cryptoicons/bidr.svg": "ef5c",
	"./cryptoicons/bifi.svg": "2385",
	"./cryptoicons/bit.svg": "418b",
	"./cryptoicons/bitci.svg": "2a21",
	"./cryptoicons/bitcoin.svg": "7ead",
	"./cryptoicons/bix.svg": "1a02",
	"./cryptoicons/bkrw.svg": "b5a6",
	"./cryptoicons/blcn.svg": "c646",
	"./cryptoicons/blink.svg": "ec02",
	"./cryptoicons/blk.svg": "2e36",
	"./cryptoicons/block.svg": "13bb",
	"./cryptoicons/blok.svg": "9b31",
	"./cryptoicons/blur.svg": "5d2a",
	"./cryptoicons/blz.svg": "a3d5",
	"./cryptoicons/bnb.svg": "bd31",
	"./cryptoicons/bnbbear.svg": "2528",
	"./cryptoicons/bnbbull.svg": "a753",
	"./cryptoicons/bnbdown.svg": "adc9",
	"./cryptoicons/bnbup.svg": "8aa0",
	"./cryptoicons/bnc.svg": "54fd",
	"./cryptoicons/bnd.svg": "a470",
	"./cryptoicons/bnt.svg": "9a9e",
	"./cryptoicons/bnty.svg": "4532",
	"./cryptoicons/bnx.svg": "be61",
	"./cryptoicons/boba.svg": "a3a4",
	"./cryptoicons/bolt.svg": "d330",
	"./cryptoicons/bome.svg": "e180",
	"./cryptoicons/bond.svg": "cc1d",
	"./cryptoicons/bone.svg": "971c",
	"./cryptoicons/bonk.svg": "1f8a",
	"./cryptoicons/booty.svg": "8644",
	"./cryptoicons/bora.svg": "2c57",
	"./cryptoicons/borg.svg": "4f52",
	"./cryptoicons/bos.svg": "1d9d",
	"./cryptoicons/boson.svg": "c113",
	"./cryptoicons/bot.svg": "2bc7",
	"./cryptoicons/bpt.svg": "79fe",
	"./cryptoicons/bq.svg": "0759",
	"./cryptoicons/bqx.svg": "63d0",
	"./cryptoicons/brd.svg": "dba4",
	"./cryptoicons/brett.svg": "fe62",
	"./cryptoicons/brick.svg": "bf8c",
	"./cryptoicons/brise.svg": "4269",
	"./cryptoicons/brl.svg": "a45e",
	"./cryptoicons/bscpad.svg": "11ac",
	"./cryptoicons/bsd.svg": "fc56",
	"./cryptoicons/bsv.svg": "18be",
	"./cryptoicons/bsw.svg": "7db9",
	"./cryptoicons/btc.svg": "bd91",
	"./cryptoicons/btcb.svg": "10c4",
	"./cryptoicons/btcd.svg": "15d6",
	"./cryptoicons/btcdown.svg": "b14a",
	"./cryptoicons/btch.svg": "dd51",
	"./cryptoicons/btcp.svg": "c065",
	"./cryptoicons/btcst.svg": "728f",
	"./cryptoicons/btcup.svg": "f423",
	"./cryptoicons/btcz.svg": "292e",
	"./cryptoicons/btdx.svg": "2a933",
	"./cryptoicons/btg.svg": "0157",
	"./cryptoicons/btm.svg": "0da3",
	"./cryptoicons/btrst.svg": "175d",
	"./cryptoicons/bts.svg": "934a",
	"./cryptoicons/btt.svg": "91a3",
	"./cryptoicons/bttc.svg": "1d3d",
	"./cryptoicons/bttold.svg": "c639",
	"./cryptoicons/btx.svg": "c771",
	"./cryptoicons/bull.svg": "9110",
	"./cryptoicons/burger.svg": "bb6f",
	"./cryptoicons/burst.svg": "5d69",
	"./cryptoicons/busd.svg": "33be",
	"./cryptoicons/buy.svg": "aeb9",
	"./cryptoicons/bvnd.svg": "c347",
	"./cryptoicons/bze.svg": "0425",
	"./cryptoicons/bzrx.svg": "669c",
	"./cryptoicons/bzz.svg": "0ce4",
	"./cryptoicons/c98.svg": "f541",
	"./cryptoicons/cad.svg": "fe9e",
	"./cryptoicons/cake.svg": "b5a8",
	"./cryptoicons/call.svg": "72c1",
	"./cryptoicons/can.svg": "c50c",
	"./cryptoicons/caps.svg": "dc11",
	"./cryptoicons/cbk.svg": "f569",
	"./cryptoicons/cbm.svg": "b465",
	"./cryptoicons/cc.svg": "7c39",
	"./cryptoicons/ccd.svg": "4a3c",
	"./cryptoicons/cdn.svg": "9419",
	"./cryptoicons/cdt.svg": "2f56",
	"./cryptoicons/ceek.svg": "f5b4",
	"./cryptoicons/cel.svg": "ccbc",
	"./cryptoicons/celo.svg": "8ca9",
	"./cryptoicons/celr.svg": "c714",
	"./cryptoicons/cennz.svg": "a158",
	"./cryptoicons/cenz.svg": "860e",
	"./cryptoicons/ceur.svg": "b311",
	"./cryptoicons/cfg.svg": "7fca",
	"./cryptoicons/cfx.svg": "fdbe",
	"./cryptoicons/cgo.svg": "555c",
	"./cryptoicons/cgpt.svg": "8d82",
	"./cryptoicons/chain.svg": "b9ad",
	"./cryptoicons/chat.svg": "f160",
	"./cryptoicons/cheel.svg": "0bf9",
	"./cryptoicons/chess.svg": "2116",
	"./cryptoicons/chf.svg": "9332",
	"./cryptoicons/chips.svg": "2b0a",
	"./cryptoicons/chng.svg": "7f93",
	"./cryptoicons/chr.svg": "6e91",
	"./cryptoicons/chsb.svg": "d2db",
	"./cryptoicons/chz.svg": "d4fc",
	"./cryptoicons/city.svg": "fec3",
	"./cryptoicons/cix.svg": "886b",
	"./cryptoicons/ckb.svg": "f1d1",
	"./cryptoicons/clam.svg": "f723",
	"./cryptoicons/cloak.svg": "9d79",
	"./cryptoicons/clp.svg": "ad61",
	"./cryptoicons/clv.svg": "7baf",
	"./cryptoicons/cmm.svg": "3fdd",
	"./cryptoicons/cmt.svg": "b6c1",
	"./cryptoicons/cnd.svg": "4621",
	"./cryptoicons/cnx.svg": "081d",
	"./cryptoicons/cny.svg": "83b3",
	"./cryptoicons/cob.svg": "ca9a",
	"./cryptoicons/cocos.svg": "953a",
	"./cryptoicons/colx.svg": "136d",
	"./cryptoicons/combo.svg": "b0d8",
	"./cryptoicons/comp.svg": "47c9",
	"./cryptoicons/cop.svg": "90e0",
	"./cryptoicons/coqui.svg": "cb93",
	"./cryptoicons/core.svg": "dc82",
	"./cryptoicons/cos.svg": "f781",
	"./cryptoicons/cot.svg": "ff3a",
	"./cryptoicons/coti.svg": "989f",
	"./cryptoicons/coval.svg": "2551",
	"./cryptoicons/cover.svg": "6934",
	"./cryptoicons/coverold.svg": "62cc",
	"./cryptoicons/cph.svg": "37da",
	"./cryptoicons/cqt.svg": "7d17",
	"./cryptoicons/cream.svg": "02423",
	"./cryptoicons/cred.svg": "378a",
	"./cryptoicons/cro.svg": "023e",
	"./cryptoicons/crpt.svg": "fdaa",
	"./cryptoicons/crts.svg": "a84b",
	"./cryptoicons/cru.svg": "4b0d",
	"./cryptoicons/crv.svg": "eee0",
	"./cryptoicons/crw.svg": "5397",
	"./cryptoicons/cs.svg": "f5d4",
	"./cryptoicons/cspr.svg": "69a7",
	"./cryptoicons/ctc.svg": "7797",
	"./cryptoicons/ctk.svg": "851e",
	"./cryptoicons/ctr.svg": "d5a6",
	"./cryptoicons/ctsi.svg": "6861",
	"./cryptoicons/ctxc.svg": "a704",
	"./cryptoicons/cudos.svg": "ae04",
	"./cryptoicons/cult.svg": "3cb2",
	"./cryptoicons/cusd.svg": "fe06",
	"./cryptoicons/cvc.svg": "513e",
	"./cryptoicons/cvp.svg": "f964",
	"./cryptoicons/cvtx.svg": "1a8c5",
	"./cryptoicons/cvx.svg": "0c5b",
	"./cryptoicons/cweb.svg": "5b58",
	"./cryptoicons/cyber.svg": "07ff",
	"./cryptoicons/czk.svg": "a850",
	"./cryptoicons/d.svg": "cf02",
	"./cryptoicons/dag.svg": "eecd",
	"./cryptoicons/dai.svg": "2f25",
	"./cryptoicons/dao.svg": "700b",
	"./cryptoicons/dar.svg": "6b9f",
	"./cryptoicons/dash.svg": "4ee2",
	"./cryptoicons/dat.svg": "65d9",
	"./cryptoicons/data.svg": "245f",
	"./cryptoicons/dbc.svg": "a18d",
	"./cryptoicons/dc.svg": "e6df",
	"./cryptoicons/dcn.svg": "5a39",
	"./cryptoicons/dcr.svg": "88c8",
	"./cryptoicons/deez.svg": "402e",
	"./cryptoicons/dego.svg": "1331",
	"./cryptoicons/dent.svg": "b9d0",
	"./cryptoicons/deso.svg": "6818",
	"./cryptoicons/dew.svg": "d809",
	"./cryptoicons/dexe.svg": "3b03",
	"./cryptoicons/dext.svg": "b2da",
	"./cryptoicons/df.svg": "64ee",
	"./cryptoicons/dfi.svg": "4789",
	"./cryptoicons/dgb.svg": "1801",
	"./cryptoicons/dgd.svg": "2df5",
	"./cryptoicons/dia.svg": "5064",
	"./cryptoicons/dimo.svg": "131c",
	"./cryptoicons/dione.svg": "09a3",
	"./cryptoicons/dka.svg": "4840",
	"./cryptoicons/dkk.svg": "38bb",
	"./cryptoicons/dlc.svg": "ffc3",
	"./cryptoicons/dlt.svg": "a265",
	"./cryptoicons/dmtr.svg": "791e",
	"./cryptoicons/dnt.svg": "b1bc",
	"./cryptoicons/dnx.svg": "b0ee",
	"./cryptoicons/dock.svg": "a055",
	"./cryptoicons/dodo.svg": "2f566",
	"./cryptoicons/doge.svg": "b977",
	"./cryptoicons/dome.svg": "3597",
	"./cryptoicons/don.svg": "e3c8",
	"./cryptoicons/dot.svg": "4337",
	"./cryptoicons/dotdown.svg": "006f",
	"./cryptoicons/dotup.svg": "3e6a",
	"./cryptoicons/drep.svg": "a7f0",
	"./cryptoicons/drepold.svg": "86c88",
	"./cryptoicons/drgn.svg": "97a0",
	"./cryptoicons/drop.svg": "16d7",
	"./cryptoicons/dta.svg": "75ed",
	"./cryptoicons/dth.svg": "f128",
	"./cryptoicons/dtr.svg": "09d1",
	"./cryptoicons/dusk.svg": "256c",
	"./cryptoicons/dust.svg": "7657",
	"./cryptoicons/dvi.svg": "3300",
	"./cryptoicons/dydx.svg": "5976",
	"./cryptoicons/dym.svg": "158e",
	"./cryptoicons/dzd.svg": "8ce4",
	"./cryptoicons/easy.svg": "3695",
	"./cryptoicons/ebst.svg": "f926",
	"./cryptoicons/eca.svg": "a100",
	"./cryptoicons/edg.svg": "5c96",
	"./cryptoicons/edo.svg": "f08a",
	"./cryptoicons/edoge.svg": "37af",
	"./cryptoicons/edu.svg": "2931",
	"./cryptoicons/efi.svg": "34d5",
	"./cryptoicons/egld.svg": "a50f",
	"./cryptoicons/ela.svg": "5ea0",
	"./cryptoicons/elec.svg": "ed15",
	"./cryptoicons/elf.svg": "a329",
	"./cryptoicons/elix.svg": "6c30",
	"./cryptoicons/ella.svg": "8306",
	"./cryptoicons/elon.svg": "5a05",
	"./cryptoicons/emb.svg": "89e0",
	"./cryptoicons/emc.svg": "5c62",
	"./cryptoicons/emc2.svg": "bbf9",
	"./cryptoicons/ena.svg": "f828",
	"./cryptoicons/eng.svg": "c4ef",
	"./cryptoicons/enj.svg": "5a45",
	"./cryptoicons/ens.svg": "5be6",
	"./cryptoicons/entrp.svg": "1456",
	"./cryptoicons/eon.svg": "a867",
	"./cryptoicons/eop.svg": "f266",
	"./cryptoicons/eos.svg": "29212",
	"./cryptoicons/eosbear.svg": "16a1",
	"./cryptoicons/eosbull.svg": "fca4",
	"./cryptoicons/eosdown.svg": "3b2a",
	"./cryptoicons/eosup.svg": "1f91",
	"./cryptoicons/eps.svg": "d4a6",
	"./cryptoicons/epx.svg": "0f3a",
	"./cryptoicons/eqli.svg": "53fd",
	"./cryptoicons/equa.svg": "e07a",
	"./cryptoicons/erd.svg": "84bd",
	"./cryptoicons/erg.svg": "a2fa",
	"./cryptoicons/ern.svg": "4df8",
	"./cryptoicons/etb.svg": "38cc",
	"./cryptoicons/etc.svg": "9ac5",
	"./cryptoicons/etf.svg": "b893",
	"./cryptoicons/eth.svg": "84a3",
	"./cryptoicons/ethbear.svg": "a042",
	"./cryptoicons/ethbnt.svg": "768b",
	"./cryptoicons/ethbull.svg": "5742",
	"./cryptoicons/ethdown.svg": "250e",
	"./cryptoicons/ethdydx.svg": "e0dc",
	"./cryptoicons/ethfi.svg": "f0dc",
	"./cryptoicons/ethos.svg": "fc53",
	"./cryptoicons/ethup.svg": "0892",
	"./cryptoicons/ethw.svg": "86fb",
	"./cryptoicons/etn.svg": "968a",
	"./cryptoicons/etp.svg": "a84d",
	"./cryptoicons/eur.svg": "d55c",
	"./cryptoicons/euroc.svg": "41cb",
	"./cryptoicons/eurt.svg": "1509",
	"./cryptoicons/eva.svg": "be9e",
	"./cryptoicons/ever.svg": "c179",
	"./cryptoicons/evx.svg": "3204",
	"./cryptoicons/ewt.svg": "d5b5",
	"./cryptoicons/exmo.svg": "1f5f",
	"./cryptoicons/exp.svg": "da0c",
	"./cryptoicons/ez.svg": "cce1",
	"./cryptoicons/fair.svg": "1b4b",
	"./cryptoicons/farm.svg": "db9b",
	"./cryptoicons/fct.svg": "5a36",
	"./cryptoicons/fct2.svg": "84c0",
	"./cryptoicons/fdusd.svg": "0e4b",
	"./cryptoicons/fei.svg": "6f48",
	"./cryptoicons/fer.svg": "5d49",
	"./cryptoicons/fet.svg": "01f4",
	"./cryptoicons/fida.svg": "dbf7",
	"./cryptoicons/fil.svg": "eccb",
	"./cryptoicons/fildown.svg": "9bae",
	"./cryptoicons/filup.svg": "b143",
	"./cryptoicons/fio.svg": "65fe",
	"./cryptoicons/firo.svg": "bb16",
	"./cryptoicons/fis.svg": "359e",
	"./cryptoicons/fitfi.svg": "a952",
	"./cryptoicons/fjc.svg": "8c8e",
	"./cryptoicons/fldc.svg": "06b0",
	"./cryptoicons/flm.svg": "caf6",
	"./cryptoicons/flo.svg": "7eb9",
	"./cryptoicons/floki.svg": "3ca4",
	"./cryptoicons/flow.svg": "126a",
	"./cryptoicons/flr.svg": "e7b9",
	"./cryptoicons/flux.svg": "2d59",
	"./cryptoicons/fncy.svg": "61d3",
	"./cryptoicons/fnsa.svg": "d1de",
	"./cryptoicons/for.svg": "1b75",
	"./cryptoicons/fort.svg": "a397",
	"./cryptoicons/forth.svg": "8992",
	"./cryptoicons/fox.svg": "1a05",
	"./cryptoicons/fra.svg": "cb8a",
	"./cryptoicons/frax.svg": "e67f",
	"./cryptoicons/front.svg": "796f",
	"./cryptoicons/fsn.svg": "971e",
	"./cryptoicons/ftc.svg": "a61e",
	"./cryptoicons/ftm.svg": "0031",
	"./cryptoicons/ftn.svg": "f8b8",
	"./cryptoicons/ftt.svg": "1405",
	"./cryptoicons/fuel.svg": "e2b5",
	"./cryptoicons/fun.svg": "ff49",
	"./cryptoicons/fuse.svg": "10c43",
	"./cryptoicons/fx.svg": "4b4d",
	"./cryptoicons/fxs.svg": "2fd1",
	"./cryptoicons/gafi.svg": "1a58a",
	"./cryptoicons/gal.svg": "755a",
	"./cryptoicons/gala.svg": "ebbd",
	"./cryptoicons/game.svg": "ff44",
	"./cryptoicons/gas.svg": "40f6",
	"./cryptoicons/gbp.svg": "d72d",
	"./cryptoicons/gbx.svg": "1402",
	"./cryptoicons/gbyte.svg": "ab4b",
	"./cryptoicons/gel.svg": "ba8c",
	"./cryptoicons/generic.svg": "4a82",
	"./cryptoicons/gfal.svg": "6167",
	"./cryptoicons/gfi.svg": "fbbf",
	"./cryptoicons/gft.svg": "10b1",
	"./cryptoicons/ghs.svg": "47fe",
	"./cryptoicons/ghst.svg": "7458",
	"./cryptoicons/gin.svg": "3907",
	"./cryptoicons/glm.svg": "baf1",
	"./cryptoicons/glmr.svg": "c7da",
	"./cryptoicons/glxt.svg": "02cd",
	"./cryptoicons/gmm.svg": "001e",
	"./cryptoicons/gmmt.svg": "2bba",
	"./cryptoicons/gmr.svg": "1613",
	"./cryptoicons/gmt.svg": "9e65",
	"./cryptoicons/gmx.svg": "2a86",
	"./cryptoicons/gno.svg": "218f",
	"./cryptoicons/gns.svg": "6bdd",
	"./cryptoicons/gnt.svg": "0673",
	"./cryptoicons/go.svg": "ce9f",
	"./cryptoicons/gods.svg": "d561",
	"./cryptoicons/gog.svg": "78e3",
	"./cryptoicons/gold.svg": "9e6c",
	"./cryptoicons/grc.svg": "a997",
	"./cryptoicons/grin.svg": "d799",
	"./cryptoicons/grnd.svg": "8e6e",
	"./cryptoicons/grs.svg": "aa5e",
	"./cryptoicons/grt.svg": "4fa6",
	"./cryptoicons/grtdown.svg": "5121",
	"./cryptoicons/grtup.svg": "8d88",
	"./cryptoicons/grv.svg": "11c1",
	"./cryptoicons/gsc.svg": "20aa",
	"./cryptoicons/gst.svg": "785b",
	"./cryptoicons/gt.svg": "96ed",
	"./cryptoicons/gtc.svg": "ed3c",
	"./cryptoicons/gto.svg": "26c9",
	"./cryptoicons/gup.svg": "9047",
	"./cryptoicons/gusd.svg": "3645",
	"./cryptoicons/gvt.svg": "224f",
	"./cryptoicons/gxa.svg": "6d93",
	"./cryptoicons/gxs.svg": "4334",
	"./cryptoicons/gyen.svg": "0d6c",
	"./cryptoicons/gzone.svg": "8cc9",
	"./cryptoicons/gzr.svg": "925a",
	"./cryptoicons/h2o.svg": "794b",
	"./cryptoicons/hai.svg": "f97b",
	"./cryptoicons/hard.svg": "857f",
	"./cryptoicons/hbar.svg": "c8bb",
	"./cryptoicons/hc.svg": "7925",
	"./cryptoicons/hcc.svg": "bd82",
	"./cryptoicons/hegic.svg": "ff89",
	"./cryptoicons/hello.svg": "665b",
	"./cryptoicons/hero.svg": "4dc1",
	"./cryptoicons/hex.svg": "3cdc",
	"./cryptoicons/hft.svg": "b684",
	"./cryptoicons/hifi.svg": "8edc",
	"./cryptoicons/high.svg": "5805",
	"./cryptoicons/hight.svg": "0cf7",
	"./cryptoicons/hive.svg": "5e5c",
	"./cryptoicons/hkd.svg": "df55",
	"./cryptoicons/hns.svg": "5cb1",
	"./cryptoicons/hnst.svg": "2b69",
	"./cryptoicons/hnt.svg": "2e04",
	"./cryptoicons/hodl.svg": "84e6",
	"./cryptoicons/hook.svg": "34b3",
	"./cryptoicons/hopr.svg": "39f8",
	"./cryptoicons/hot.svg": "87ef",
	"./cryptoicons/hpb.svg": "03f1",
	"./cryptoicons/hrk.svg": "11eb",
	"./cryptoicons/hsf.svg": "078e",
	"./cryptoicons/hsr.svg": "87ba",
	"./cryptoicons/ht.svg": "ec63",
	"./cryptoicons/html.svg": "1eef",
	"./cryptoicons/htr.svg": "f69f",
	"./cryptoicons/huc.svg": "1ec0",
	"./cryptoicons/huf.svg": "1983",
	"./cryptoicons/husd.svg": "66f4",
	"./cryptoicons/hush.svg": "82a7",
	"./cryptoicons/hvh.svg": "c47b",
	"./cryptoicons/hydra.svg": "709e",
	"./cryptoicons/icn.svg": "917d",
	"./cryptoicons/icp.svg": "2675",
	"./cryptoicons/icx.svg": "d0cb",
	"./cryptoicons/id.svg": "1535",
	"./cryptoicons/idex.svg": "6d0a",
	"./cryptoicons/idr.svg": "d4ac",
	"./cryptoicons/idrt.svg": "a1ef",
	"./cryptoicons/ignis.svg": "dea9",
	"./cryptoicons/ilk.svg": "1567",
	"./cryptoicons/ilv.svg": "e255",
	"./cryptoicons/imgnai.svg": "b39f",
	"./cryptoicons/imx.svg": "f869",
	"./cryptoicons/inj.svg": "710a",
	"./cryptoicons/ink.svg": "807e",
	"./cryptoicons/inr.svg": "6419",
	"./cryptoicons/ins.svg": "085d",
	"./cryptoicons/inter.svg": "a608",
	"./cryptoicons/ion.svg": "31e7",
	"./cryptoicons/iop.svg": "0a6c",
	"./cryptoicons/iost.svg": "dd46",
	"./cryptoicons/iota.svg": "7ce6",
	"./cryptoicons/iotx.svg": "3627",
	"./cryptoicons/iq.svg": "d719",
	"./cryptoicons/iris.svg": "8adb",
	"./cryptoicons/itc.svg": "b512",
	"./cryptoicons/izi.svg": "8685",
	"./cryptoicons/jasmy.svg": "727c",
	"./cryptoicons/jewel.svg": "c055",
	"./cryptoicons/jex.svg": "089d",
	"./cryptoicons/jnt.svg": "9c9b",
	"./cryptoicons/jod.svg": "5135",
	"./cryptoicons/joe.svg": "7e04",
	"./cryptoicons/jpy.svg": "53f9",
	"./cryptoicons/jst.svg": "9e9f",
	"./cryptoicons/jup.svg": "d489",
	"./cryptoicons/juv.svg": "8fde",
	"./cryptoicons/kai.svg": "5636",
	"./cryptoicons/kalm.svg": "90d6",
	"./cryptoicons/kan.svg": "b567",
	"./cryptoicons/kar.svg": "a900",
	"./cryptoicons/kas.svg": "a0cb",
	"./cryptoicons/kata.svg": "5967",
	"./cryptoicons/kava.svg": "a822",
	"./cryptoicons/kcs.svg": "16ba",
	"./cryptoicons/kda.svg": "ee82",
	"./cryptoicons/keep.svg": "a877",
	"./cryptoicons/kes.svg": "04bb",
	"./cryptoicons/key.svg": "e0eb",
	"./cryptoicons/keyfi.svg": "b666",
	"./cryptoicons/kgs.svg": "62b4",
	"./cryptoicons/khr.svg": "de4d",
	"./cryptoicons/kilt.svg": "2557",
	"./cryptoicons/kin.svg": "5429",
	"./cryptoicons/kishu.svg": "4f84",
	"./cryptoicons/klay.svg": "e70e",
	"./cryptoicons/klown.svg": "56b1",
	"./cryptoicons/klv.svg": "d8cf",
	"./cryptoicons/kmd.svg": "22d6",
	"./cryptoicons/knc.svg": "0f3b",
	"./cryptoicons/kncl.svg": "3872",
	"./cryptoicons/kp3r.svg": "a32b",
	"./cryptoicons/krb.svg": "814d",
	"./cryptoicons/krl.svg": "673d",
	"./cryptoicons/ksm.svg": "66fd",
	"./cryptoicons/kuji.svg": "b107",
	"./cryptoicons/kwd.svg": "8c73",
	"./cryptoicons/kwenta.svg": "91ff",
	"./cryptoicons/kzt.svg": "04c9",
	"./cryptoicons/ladys.svg": "c350",
	"./cryptoicons/lak.svg": "d00c",
	"./cryptoicons/lat.svg": "5bdb",
	"./cryptoicons/lazio.svg": "8d96",
	"./cryptoicons/lba.svg": "2eed",
	"./cryptoicons/lbc.svg": "842c",
	"./cryptoicons/lcx.svg": "c05d",
	"./cryptoicons/ldo.svg": "8c99",
	"./cryptoicons/leash.svg": "25c5",
	"./cryptoicons/lend.svg": "46d7",
	"./cryptoicons/leo.svg": "ccdf",
	"./cryptoicons/lever.svg": "4b31",
	"./cryptoicons/lina.svg": "c9d6",
	"./cryptoicons/link.svg": "6e49",
	"./cryptoicons/linkdown.svg": "f832",
	"./cryptoicons/linkup.svg": "afa1",
	"./cryptoicons/lit.svg": "66df",
	"./cryptoicons/lkk.svg": "eeaf",
	"./cryptoicons/lmwr.svg": "cb12",
	"./cryptoicons/locus.svg": "33c0",
	"./cryptoicons/loka.svg": "84b7",
	"./cryptoicons/lon.svg": "a22d",
	"./cryptoicons/looks.svg": "e560",
	"./cryptoicons/loom.svg": "7cad",
	"./cryptoicons/loomold.svg": "eba1",
	"./cryptoicons/lpt.svg": "847a",
	"./cryptoicons/lqty.svg": "5b4e",
	"./cryptoicons/lrc.svg": "e3b3",
	"./cryptoicons/lsk.svg": "5e1f",
	"./cryptoicons/ltc.svg": "eb8c",
	"./cryptoicons/ltcdown.svg": "fd9d",
	"./cryptoicons/ltcup.svg": "df49",
	"./cryptoicons/lto.svg": "e7b3",
	"./cryptoicons/ltoold.svg": "cdb1",
	"./cryptoicons/lun.svg": "6de1",
	"./cryptoicons/luna.svg": "aa37",
	"./cryptoicons/lunc.svg": "67a1",
	"./cryptoicons/lyd.svg": "85a7",
	"./cryptoicons/lyx.svg": "1d92",
	"./cryptoicons/ma.svg": "573e",
	"./cryptoicons/magic.svg": "b842",
	"./cryptoicons/maid.svg": "ba8d",
	"./cryptoicons/man.svg": "ffd1",
	"./cryptoicons/mana.svg": "4224",
	"./cryptoicons/manta.svg": "8bac",
	"./cryptoicons/mapo.svg": "be25",
	"./cryptoicons/mask.svg": "cab5",
	"./cryptoicons/math.svg": "9007",
	"./cryptoicons/matic.svg": "b148",
	"./cryptoicons/mav.svg": "a974",
	"./cryptoicons/max.svg": "c06b",
	"./cryptoicons/mbl.svg": "cb98",
	"./cryptoicons/mbox.svg": "88cc",
	"./cryptoicons/mbx.svg": "183e",
	"./cryptoicons/mc.svg": "b6ec",
	"./cryptoicons/mcap.svg": "754f",
	"./cryptoicons/mcb.svg": "1d37",
	"./cryptoicons/mco.svg": "b44c",
	"./cryptoicons/mda.svg": "7561",
	"./cryptoicons/mds.svg": "f1ce",
	"./cryptoicons/mdt.svg": "7e2d",
	"./cryptoicons/mdx.svg": "e3d1",
	"./cryptoicons/med.svg": "b1cc",
	"./cryptoicons/meetone.svg": "5f73",
	"./cryptoicons/meme.svg": "3626",
	"./cryptoicons/merl.svg": "e9ba",
	"./cryptoicons/meta.svg": "6c15",
	"./cryptoicons/metis.svg": "f587",
	"./cryptoicons/mev.svg": "b11b",
	"./cryptoicons/mft.svg": "c19c",
	"./cryptoicons/mina.svg": "e482",
	"./cryptoicons/miota.svg": "58fd",
	"./cryptoicons/mir.svg": "a5b7",
	"./cryptoicons/mith.svg": "92bc",
	"./cryptoicons/mkr.svg": "7118b",
	"./cryptoicons/mlk.svg": "6f03",
	"./cryptoicons/mln.svg": "2c2d",
	"./cryptoicons/mlt.svg": "12f5",
	"./cryptoicons/mngo.svg": "b1b3",
	"./cryptoicons/mnt.svg": "f250",
	"./cryptoicons/mnw.svg": "7ba7",
	"./cryptoicons/mnx.svg": "77d8",
	"./cryptoicons/mnz.svg": "a655",
	"./cryptoicons/moac.svg": "cb4f",
	"./cryptoicons/mob.svg": "9268",
	"./cryptoicons/mobile.svg": "1155",
	"./cryptoicons/moc.svg": "21ae",
	"./cryptoicons/mod.svg": "f1f2",
	"./cryptoicons/mog.svg": "1fea",
	"./cryptoicons/mona.svg": "1d22",
	"./cryptoicons/moon.svg": "91ba",
	"./cryptoicons/movr.svg": "36bb",
	"./cryptoicons/mpl.svg": "b694",
	"./cryptoicons/msol.svg": "767d",
	"./cryptoicons/msr.svg": "5c26",
	"./cryptoicons/mth.svg": "b0ba",
	"./cryptoicons/mtl.svg": "1bd9",
	"./cryptoicons/mtlx.svg": "1379",
	"./cryptoicons/mtrg.svg": "cbf3",
	"./cryptoicons/mubi.svg": "96c9",
	"./cryptoicons/multi.svg": "0ee9",
	"./cryptoicons/music.svg": "828a",
	"./cryptoicons/mvl.svg": "7e41",
	"./cryptoicons/mx.svg": "4449",
	"./cryptoicons/mxc.svg": "0604",
	"./cryptoicons/mxn.svg": "18e8",
	"./cryptoicons/myria.svg": "e42d",
	"./cryptoicons/mzc.svg": "dfd2",
	"./cryptoicons/naka.svg": "2ad6",
	"./cryptoicons/nano.svg": "80c1",
	"./cryptoicons/nas.svg": "6fb3",
	"./cryptoicons/nav.svg": "d66f",
	"./cryptoicons/nbs.svg": "56e4",
	"./cryptoicons/ncash.svg": "f0f2",
	"./cryptoicons/nct.svg": "a976",
	"./cryptoicons/ndz.svg": "a802",
	"./cryptoicons/near.svg": "c947",
	"./cryptoicons/nebl.svg": "6299",
	"./cryptoicons/neo.svg": "83b4",
	"./cryptoicons/neos.svg": "b31d",
	"./cryptoicons/nest.svg": "c1c1",
	"./cryptoicons/neu.svg": "09f8",
	"./cryptoicons/nexa.svg": "e5d6",
	"./cryptoicons/nexo.svg": "9120",
	"./cryptoicons/nft.svg": "d248",
	"./cryptoicons/nftx.svg": "e8a9",
	"./cryptoicons/ngc.svg": "2f69",
	"./cryptoicons/ngn.svg": "c400",
	"./cryptoicons/nim.svg": "9fa5",
	"./cryptoicons/nio.svg": "a153",
	"./cryptoicons/nkn.svg": "5e23",
	"./cryptoicons/nlc2.svg": "212d",
	"./cryptoicons/nlg.svg": "47a1",
	"./cryptoicons/nmc.svg": "a793",
	"./cryptoicons/nmr.svg": "15674",
	"./cryptoicons/noia.svg": "b362",
	"./cryptoicons/nok.svg": "6b96",
	"./cryptoicons/not.svg": "c9df",
	"./cryptoicons/npt.svg": "0f09",
	"./cryptoicons/npxs.svg": "089c",
	"./cryptoicons/nsbt.svg": "8118",
	"./cryptoicons/ntbc.svg": "0aee",
	"./cryptoicons/ntrn.svg": "a07f",
	"./cryptoicons/ntx.svg": "c877",
	"./cryptoicons/nu.svg": "4f59",
	"./cryptoicons/nuls.svg": "d83e",
	"./cryptoicons/num.svg": "50d6",
	"./cryptoicons/nvir.svg": "299f",
	"./cryptoicons/nvt.svg": "c640",
	"./cryptoicons/nwc.svg": "8b63",
	"./cryptoicons/nxra.svg": "641b",
	"./cryptoicons/nxs.svg": "52ef",
	"./cryptoicons/nxt.svg": "f10b",
	"./cryptoicons/nym.svg": "fb1c",
	"./cryptoicons/nzd.svg": "6b59",
	"./cryptoicons/oas.svg": "2207",
	"./cryptoicons/oax.svg": "97f0",
	"./cryptoicons/obsr.svg": "a0be",
	"./cryptoicons/ocean.svg": "9880",
	"./cryptoicons/og.svg": "6c46",
	"./cryptoicons/ogn.svg": "93fb",
	"./cryptoicons/ogv.svg": "bce5",
	"./cryptoicons/ok.svg": "3fff",
	"./cryptoicons/okb.svg": "f156",
	"./cryptoicons/om.svg": "85bb",
	"./cryptoicons/omg.svg": "66ff",
	"./cryptoicons/omni.svg": "033c",
	"./cryptoicons/omold.svg": "5c29",
	"./cryptoicons/omr.svg": "845e",
	"./cryptoicons/ondo.svg": "985c",
	"./cryptoicons/one.svg": "7da9",
	"./cryptoicons/ong.svg": "bd3b",
	"./cryptoicons/ont.svg": "7b45",
	"./cryptoicons/onx.svg": "124c",
	"./cryptoicons/ooki.svg": "99ca",
	"./cryptoicons/oot.svg": "22e7",
	"./cryptoicons/op.svg": "a240",
	"./cryptoicons/opti.svg": "4c02",
	"./cryptoicons/opul.svg": "a814",
	"./cryptoicons/orai.svg": "fbbc",
	"./cryptoicons/orb.svg": "7288",
	"./cryptoicons/orbr.svg": "b96d",
	"./cryptoicons/orbs.svg": "3093",
	"./cryptoicons/orc.svg": "d9eb",
	"./cryptoicons/orca.svg": "fa03",
	"./cryptoicons/ordi.svg": "1694",
	"./cryptoicons/orn.svg": "0514",
	"./cryptoicons/osmo.svg": "e37c",
	"./cryptoicons/ost.svg": "9a0e",
	"./cryptoicons/ousd.svg": "0d9a",
	"./cryptoicons/ox.svg": "fc5d",
	"./cryptoicons/oxt.svg": "1ed8",
	"./cryptoicons/paal.svg": "54ff",
	"./cryptoicons/para.svg": "9e49",
	"./cryptoicons/part.svg": "84f4",
	"./cryptoicons/pasc.svg": "34c5",
	"./cryptoicons/pasl.svg": "3499",
	"./cryptoicons/pax.svg": "4cb8",
	"./cryptoicons/paxg.svg": "a171",
	"./cryptoicons/pay.svg": "1c15",
	"./cryptoicons/payx.svg": "a9f8",
	"./cryptoicons/peel.svg": "508a",
	"./cryptoicons/pen.svg": "8b19",
	"./cryptoicons/pendle.svg": "3a0f",
	"./cryptoicons/people.svg": "b361",
	"./cryptoicons/pepe.svg": "486c",
	"./cryptoicons/perl.svg": "ed28",
	"./cryptoicons/perlold.svg": "9504",
	"./cryptoicons/perp.svg": "0c79",
	"./cryptoicons/pha.svg": "bf9b",
	"./cryptoicons/phb.svg": "35ae",
	"./cryptoicons/phbv1.svg": "63d1",
	"./cryptoicons/php.svg": "033b",
	"./cryptoicons/pink.svg": "7345",
	"./cryptoicons/pirl.svg": "e0a1",
	"./cryptoicons/pit.svg": "eb17",
	"./cryptoicons/pivx.svg": "30a6",
	"./cryptoicons/pixel.svg": "e8c5",
	"./cryptoicons/pkf.svg": "8b6e",
	"./cryptoicons/pla.svg": "2fd2",
	"./cryptoicons/pln.svg": "468f",
	"./cryptoicons/plr.svg": "ae6e",
	"./cryptoicons/plu.svg": "d374",
	"./cryptoicons/pnk.svg": "f3d6",
	"./cryptoicons/pnt.svg": "df30",
	"./cryptoicons/poa.svg": "514b",
	"./cryptoicons/poe.svg": "c9ca",
	"./cryptoicons/pokt.svg": "d4c7",
	"./cryptoicons/polis.svg": "ad8c",
	"./cryptoicons/pols.svg": "155d",
	"./cryptoicons/poly.svg": "4e14",
	"./cryptoicons/polyx.svg": "8a0f",
	"./cryptoicons/pond.svg": "8176",
	"./cryptoicons/ponke.svg": "44a4",
	"./cryptoicons/poolx.svg": "230a",
	"./cryptoicons/popcat.svg": "8110",
	"./cryptoicons/porto.svg": "33a3",
	"./cryptoicons/pot.svg": "d983",
	"./cryptoicons/powr.svg": "7201",
	"./cryptoicons/ppc.svg": "99fb",
	"./cryptoicons/ppp.svg": "d589",
	"./cryptoicons/ppt.svg": "fcca",
	"./cryptoicons/pre.svg": "20c5",
	"./cryptoicons/prime.svg": "41ed",
	"./cryptoicons/prl.svg": "d50f",
	"./cryptoicons/pro.svg": "5058",
	"./cryptoicons/prom.svg": "d45a",
	"./cryptoicons/propc.svg": "9d63",
	"./cryptoicons/pros.svg": "4eb8",
	"./cryptoicons/prq.svg": "e181",
	"./cryptoicons/psg.svg": "489c",
	"./cryptoicons/psp.svg": "9bb9",
	"./cryptoicons/pts.svg": "36c8",
	"./cryptoicons/pundix.svg": "334f",
	"./cryptoicons/pungo.svg": "e22e",
	"./cryptoicons/pura.svg": "0c2a",
	"./cryptoicons/purse.svg": "514c",
	"./cryptoicons/push.svg": "f44f",
	"./cryptoicons/pyr.svg": "be34",
	"./cryptoicons/pyrold.svg": "9195",
	"./cryptoicons/pyth.svg": "f4b7",
	"./cryptoicons/pyusd.svg": "25e6",
	"./cryptoicons/qash.svg": "c105",
	"./cryptoicons/qi.svg": "cda4",
	"./cryptoicons/qiswap.svg": "7f3e",
	"./cryptoicons/qiwi.svg": "9d7d",
	"./cryptoicons/qkc.svg": "a50d",
	"./cryptoicons/qlc.svg": "0d4c",
	"./cryptoicons/qnt.svg": "a67b",
	"./cryptoicons/qrl.svg": "1180",
	"./cryptoicons/qsp.svg": "eb7c",
	"./cryptoicons/qtcon.svg": "0a02",
	"./cryptoicons/qtum.svg": "8f36",
	"./cryptoicons/quack.svg": "aff2",
	"./cryptoicons/quick.svg": "b449",
	"./cryptoicons/r.svg": "1b04",
	"./cryptoicons/raca.svg": "96c7",
	"./cryptoicons/rad.svg": "9e7e",
	"./cryptoicons/rads.svg": "b827",
	"./cryptoicons/rai.svg": "53d1",
	"./cryptoicons/ramp.svg": "d38b",
	"./cryptoicons/rap.svg": "966f",
	"./cryptoicons/rare.svg": "b296",
	"./cryptoicons/rari.svg": "e661",
	"./cryptoicons/ray.svg": "f029",
	"./cryptoicons/rbls.svg": "559c",
	"./cryptoicons/rbn.svg": "8ee2",
	"./cryptoicons/rcn.svg": "882b",
	"./cryptoicons/rdd.svg": "be46",
	"./cryptoicons/rdn.svg": "53ab",
	"./cryptoicons/rdnt.svg": "2c8b",
	"./cryptoicons/reef.svg": "1223",
	"./cryptoicons/rei.svg": "3145",
	"./cryptoicons/ren.svg": "d2bd",
	"./cryptoicons/renbtc.svg": "5dac",
	"./cryptoicons/rep.svg": "408f",
	"./cryptoicons/repv1.svg": "bcd9",
	"./cryptoicons/repv2.svg": "8a19",
	"./cryptoicons/req.svg": "f7b7",
	"./cryptoicons/revv.svg": "a31e",
	"./cryptoicons/rfox.svg": "9b40",
	"./cryptoicons/rgt.svg": "7885",
	"./cryptoicons/rhoc.svg": "bf82",
	"./cryptoicons/ric.svg": "86f6",
	"./cryptoicons/rif.svg": "c2bb",
	"./cryptoicons/rise.svg": "caf2",
	"./cryptoicons/rlc.svg": "5977",
	"./cryptoicons/rly.svg": "d2ec",
	"./cryptoicons/rmrk.svg": "8076",
	"./cryptoicons/rndr.svg": "c49b",
	"./cryptoicons/ron.svg": "54da",
	"./cryptoicons/rose.svg": "440f",
	"./cryptoicons/route.svg": "95b5",
	"./cryptoicons/rpl.svg": "c136",
	"./cryptoicons/rpx.svg": "1655",
	"./cryptoicons/rsr.svg": "5b05",
	"./cryptoicons/rss3.svg": "fc3f",
	"./cryptoicons/rub.svg": "f7ef",
	"./cryptoicons/rune.svg": "3238",
	"./cryptoicons/rvf.svg": "ffa4",
	"./cryptoicons/rvn.svg": "3e0d",
	"./cryptoicons/ryo.svg": "0dfc",
	"./cryptoicons/safe.svg": "6556",
	"./cryptoicons/safemoon.svg": "04ec",
	"./cryptoicons/sai.svg": "43c8",
	"./cryptoicons/saitama.svg": "9d03",
	"./cryptoicons/saito.svg": "763e",
	"./cryptoicons/salt.svg": "9647",
	"./cryptoicons/samo.svg": "d273",
	"./cryptoicons/san.svg": "a8bc",
	"./cryptoicons/sand.svg": "0399",
	"./cryptoicons/santos.svg": "b6a0",
	"./cryptoicons/sbd.svg": "ed2d",
	"./cryptoicons/sberbank.svg": "a664",
	"./cryptoicons/sbtc.svg": "ac4d",
	"./cryptoicons/sc.svg": "9850",
	"./cryptoicons/sclp.svg": "2b23",
	"./cryptoicons/scrt.svg": "5f62",
	"./cryptoicons/sd.svg": "8d70",
	"./cryptoicons/sdao.svg": "1afa",
	"./cryptoicons/sdex.svg": "39aa",
	"./cryptoicons/sdg.svg": "cbde",
	"./cryptoicons/sdn.svg": "d787",
	"./cryptoicons/sei.svg": "2227",
	"./cryptoicons/sek.svg": "310c",
	"./cryptoicons/sfp.svg": "93e3",
	"./cryptoicons/sfund.svg": "084b",
	"./cryptoicons/sgb.svg": "3d96",
	"./cryptoicons/sgt.svg": "2d16",
	"./cryptoicons/shib.svg": "bf22",
	"./cryptoicons/shift.svg": "568e",
	"./cryptoicons/shping.svg": "1781",
	"./cryptoicons/sib.svg": "f7f2",
	"./cryptoicons/sidus.svg": "006b",
	"./cryptoicons/sin.svg": "38b7",
	"./cryptoicons/sis.svg": "0c83",
	"./cryptoicons/six.svg": "2b88",
	"./cryptoicons/skl.svg": "4a7a",
	"./cryptoicons/sky.svg": "be68",
	"./cryptoicons/slerf.svg": "50aa6",
	"./cryptoicons/slnd.svg": "b5a1",
	"./cryptoicons/slp.svg": "4130",
	"./cryptoicons/slpold.svg": "f4bd",
	"./cryptoicons/slr.svg": "edf7",
	"./cryptoicons/sls.svg": "6032",
	"./cryptoicons/smart.svg": "065a",
	"./cryptoicons/sn.svg": "d1dc",
	"./cryptoicons/snek.svg": "8d98",
	"./cryptoicons/sngls.svg": "4ca2",
	"./cryptoicons/snm.svg": "cc3e",
	"./cryptoicons/snmold.svg": "d4cf",
	"./cryptoicons/snt.svg": "ec0e",
	"./cryptoicons/snx.svg": "69f0",
	"./cryptoicons/soc.svg": "1a2e",
	"./cryptoicons/sofi.svg": "edf8",
	"./cryptoicons/sol.svg": "0c6f",
	"./cryptoicons/solo.svg": "ea3e",
	"./cryptoicons/solve.svg": "d4e8",
	"./cryptoicons/soul.svg": "f966",
	"./cryptoicons/sov.svg": "e110",
	"./cryptoicons/spacehbit.svg": "072f",
	"./cryptoicons/spank.svg": "333b",
	"./cryptoicons/sparta.svg": "ccf3",
	"./cryptoicons/spartaold.svg": "5a9c",
	"./cryptoicons/spell.svg": "0daa",
	"./cryptoicons/sph.svg": "30c1",
	"./cryptoicons/sphtx.svg": "7292",
	"./cryptoicons/sps.svg": "8822",
	"./cryptoicons/squidgrow.svg": "3985",
	"./cryptoicons/srm.svg": "be60",
	"./cryptoicons/srn.svg": "c7cf",
	"./cryptoicons/ssv.svg": "3c66",
	"./cryptoicons/ssx.svg": "e84d",
	"./cryptoicons/stak.svg": "7710",
	"./cryptoicons/starl.svg": "f4c1",
	"./cryptoicons/start.svg": "67e4",
	"./cryptoicons/steem.svg": "d2ee",
	"./cryptoicons/steth.svg": "02ce",
	"./cryptoicons/stg.svg": "227e",
	"./cryptoicons/stmx.svg": "a9f1",
	"./cryptoicons/storj.svg": "c3bc",
	"./cryptoicons/storm.svg": "cc91",
	"./cryptoicons/stos.svg": "b9eb",
	"./cryptoicons/stox.svg": "c484",
	"./cryptoicons/stpt.svg": "223b",
	"./cryptoicons/stq.svg": "38e3",
	"./cryptoicons/strat.svg": "5d24",
	"./cryptoicons/strax.svg": "397d",
	"./cryptoicons/strk.svg": "5141",
	"./cryptoicons/stx.svg": "b0cf",
	"./cryptoicons/sub.svg": "6ce6",
	"./cryptoicons/sui.svg": "89e4",
	"./cryptoicons/suku.svg": "d765",
	"./cryptoicons/sumo.svg": "e0ea",
	"./cryptoicons/sun.svg": "3ef9",
	"./cryptoicons/sunold.svg": "e356",
	"./cryptoicons/super.svg": "eec9",
	"./cryptoicons/susd.svg": "82ff",
	"./cryptoicons/sushi.svg": "c88b",
	"./cryptoicons/sushidown.svg": "6472",
	"./cryptoicons/sushiup.svg": "cb00",
	"./cryptoicons/swap.svg": "2205",
	"./cryptoicons/sweat.svg": "e6ce",
	"./cryptoicons/swrv.svg": "abb2",
	"./cryptoicons/sxp.svg": "c726",
	"./cryptoicons/sxpdown.svg": "fb2d",
	"./cryptoicons/sxpup.svg": "0625",
	"./cryptoicons/syn.svg": "9785",
	"./cryptoicons/sys.svg": "2706",
	"./cryptoicons/t.svg": "47899",
	"./cryptoicons/taas.svg": "231b",
	"./cryptoicons/taboo.svg": "207a",
	"./cryptoicons/tama.svg": "b48d",
	"./cryptoicons/tao.svg": "e9a2",
	"./cryptoicons/tara.svg": "4a9a",
	"./cryptoicons/tau.svg": "58ba",
	"./cryptoicons/tbx.svg": "9233",
	"./cryptoicons/tct.svg": "7d40",
	"./cryptoicons/tel.svg": "f1ee",
	"./cryptoicons/ten.svg": "0a2e",
	"./cryptoicons/tern.svg": "e952",
	"./cryptoicons/tfuel.svg": "c6fb",
	"./cryptoicons/tgch.svg": "63b2",
	"./cryptoicons/theta.svg": "b2bb",
	"./cryptoicons/thn.svg": "ef16",
	"./cryptoicons/tia.svg": "18f4",
	"./cryptoicons/time.svg": "5ace",
	"./cryptoicons/titan.svg": "14cf",
	"./cryptoicons/tix.svg": "f337",
	"./cryptoicons/tkn.svg": "ca54",
	"./cryptoicons/tko.svg": "102c",
	"./cryptoicons/tks.svg": "7025",
	"./cryptoicons/tlm.svg": "c124",
	"./cryptoicons/tlos.svg": "2ad2",
	"./cryptoicons/tmt.svg": "2c66",
	"./cryptoicons/tnb.svg": "ef19",
	"./cryptoicons/tnc.svg": "da6e",
	"./cryptoicons/tnd.svg": "c62d",
	"./cryptoicons/tnt.svg": "2214",
	"./cryptoicons/tomi.svg": "ecd1",
	"./cryptoicons/tomo.svg": "61ba",
	"./cryptoicons/ton.svg": "8e8e",
	"./cryptoicons/torn.svg": "5a5f",
	"./cryptoicons/tpay.svg": "6d96",
	"./cryptoicons/tpt.svg": "c59d",
	"./cryptoicons/trac.svg": "1b69",
	"./cryptoicons/trb.svg": "40e2",
	"./cryptoicons/trias.svg": "96ae",
	"./cryptoicons/tribe.svg": "983f",
	"./cryptoicons/trig.svg": "2e95",
	"./cryptoicons/troy.svg": "d720",
	"./cryptoicons/trtl.svg": "da4c",
	"./cryptoicons/tru.svg": "2094",
	"./cryptoicons/trx.svg": "ae6b",
	"./cryptoicons/trxdown.svg": "9bf1",
	"./cryptoicons/trxup.svg": "e9d0",
	"./cryptoicons/try.svg": "4c24",
	"./cryptoicons/tsuka.svg": "73a5",
	"./cryptoicons/tt.svg": "a4de",
	"./cryptoicons/turbo.svg": "88db",
	"./cryptoicons/tusd.svg": "5bae",
	"./cryptoicons/tvk.svg": "91d2",
	"./cryptoicons/twt.svg": "4989",
	"./cryptoicons/tzc.svg": "645f",
	"./cryptoicons/tzs.svg": "5517",
	"./cryptoicons/uah.svg": "bba8",
	"./cryptoicons/ubq.svg": "cc49",
	"./cryptoicons/ufo.svg": "d804",
	"./cryptoicons/uft.svg": "6f4b",
	"./cryptoicons/ugx.svg": "ff52",
	"./cryptoicons/uma.svg": "cfe9",
	"./cryptoicons/uncx.svg": "6d57",
	"./cryptoicons/und.svg": "aacc",
	"./cryptoicons/unfi.svg": "fe4e",
	"./cryptoicons/uni.svg": "da13",
	"./cryptoicons/unibot.svg": "6ea5",
	"./cryptoicons/unidown.svg": "14b8",
	"./cryptoicons/unity.svg": "e9dd",
	"./cryptoicons/uniup.svg": "deb2",
	"./cryptoicons/uos.svg": "6bc1",
	"./cryptoicons/upp.svg": "4b98",
	"./cryptoicons/uqc.svg": "cf7f",
	"./cryptoicons/usd.svg": "c688",
	"./cryptoicons/usdc.svg": "0a20",
	"./cryptoicons/usdd.svg": "b3ba",
	"./cryptoicons/usde.svg": "f50a",
	"./cryptoicons/usdj.svg": "eb51",
	"./cryptoicons/usdp.svg": "de1a",
	"./cryptoicons/usds.svg": "56b10",
	"./cryptoicons/usdt.svg": "c1974",
	"./cryptoicons/ust.svg": "b245",
	"./cryptoicons/ustc.svg": "3d0e",
	"./cryptoicons/utk.svg": "3b76",
	"./cryptoicons/uzs.svg": "e66e",
	"./cryptoicons/vai.svg": "6607",
	"./cryptoicons/val.svg": "1281",
	"./cryptoicons/vega.svg": "4b3e",
	"./cryptoicons/velo.svg": "f275",
	"./cryptoicons/veri.svg": "137b",
	"./cryptoicons/vet.svg": "c800",
	"./cryptoicons/vext.svg": "36af",
	"./cryptoicons/vgx.svg": "45b2",
	"./cryptoicons/via.svg": "0d64",
	"./cryptoicons/vib.svg": "e9ee",
	"./cryptoicons/vibe.svg": "37d3",
	"./cryptoicons/vic.svg": "ba8b",
	"./cryptoicons/vidt.svg": "38db",
	"./cryptoicons/vinu.svg": "56e6",
	"./cryptoicons/vite.svg": "e3c0",
	"./cryptoicons/vivo.svg": "fe065",
	"./cryptoicons/vlx.svg": "5075",
	"./cryptoicons/vnd.svg": "9f12",
	"./cryptoicons/volt.svg": "b0f9",
	"./cryptoicons/voxel.svg": "f178",
	"./cryptoicons/vr.svg": "d10b",
	"./cryptoicons/vra.svg": "8c8c",
	"./cryptoicons/vrab.svg": "f00c",
	"./cryptoicons/vrc.svg": "0bfc",
	"./cryptoicons/vrsc.svg": "8c42",
	"./cryptoicons/vrt.svg": "d592",
	"./cryptoicons/vtc.svg": "d210",
	"./cryptoicons/vtho.svg": "1598",
	"./cryptoicons/vts.svg": "c874",
	"./cryptoicons/vvs.svg": "87d5",
	"./cryptoicons/vxv.svg": "24d1",
	"./cryptoicons/w.svg": "15ab",
	"./cryptoicons/wabi.svg": "b85f",
	"./cryptoicons/wagmigames.svg": "ba28",
	"./cryptoicons/wait.svg": "1cfe",
	"./cryptoicons/wan.svg": "0831",
	"./cryptoicons/waves.svg": "3010",
	"./cryptoicons/wax.svg": "54de",
	"./cryptoicons/waxp.svg": "9eaf",
	"./cryptoicons/wbeth.svg": "22f5",
	"./cryptoicons/wbnb.svg": "09bd",
	"./cryptoicons/wbtc.svg": "c4bc",
	"./cryptoicons/weeth.svg": "eb4d",
	"./cryptoicons/wemix.svg": "381b7",
	"./cryptoicons/wen.svg": "4044",
	"./cryptoicons/weth.svg": "5e31",
	"./cryptoicons/wgr.svg": "4f5c1",
	"./cryptoicons/wicc.svg": "c828",
	"./cryptoicons/wif.svg": "35ec",
	"./cryptoicons/wild.svg": "9b43",
	"./cryptoicons/win.svg": "0f5e",
	"./cryptoicons/wing.svg": "23ed",
	"./cryptoicons/wings.svg": "4b54",
	"./cryptoicons/wld.svg": "ef24",
	"./cryptoicons/wmt.svg": "55bc",
	"./cryptoicons/wncg.svg": "9461",
	"./cryptoicons/wnxm.svg": "4953",
	"./cryptoicons/woo.svg": "a124",
	"./cryptoicons/wozx.svg": "1fdc",
	"./cryptoicons/wpr.svg": "0d4c6",
	"./cryptoicons/wrld.svg": "10f5",
	"./cryptoicons/wrx.svg": "af4c",
	"./cryptoicons/wsol.svg": "de68",
	"./cryptoicons/wtc.svg": "de59",
	"./cryptoicons/wxt.svg": "01c2",
	"./cryptoicons/x.svg": "fd03",
	"./cryptoicons/xaf.svg": "f063",
	"./cryptoicons/xai.svg": "dc17",
	"./cryptoicons/xas.svg": "fb58",
	"./cryptoicons/xaut.svg": "64f8",
	"./cryptoicons/xbc.svg": "6f3e",
	"./cryptoicons/xbp.svg": "08b3",
	"./cryptoicons/xby.svg": "1c4b",
	"./cryptoicons/xcad.svg": "995b",
	"./cryptoicons/xch.svg": "99cb",
	"./cryptoicons/xcn.svg": "1dd5",
	"./cryptoicons/xcp.svg": "053b",
	"./cryptoicons/xdata.svg": "b6a8",
	"./cryptoicons/xdc.svg": "599d",
	"./cryptoicons/xdn.svg": "9381",
	"./cryptoicons/xec.svg": "2bd7",
	"./cryptoicons/xem.svg": "7a35",
	"./cryptoicons/xin.svg": "174b",
	"./cryptoicons/xlm.svg": "7656",
	"./cryptoicons/xlmdown.svg": "611b",
	"./cryptoicons/xlmup.svg": "2b94",
	"./cryptoicons/xmcc.svg": "4aff",
	"./cryptoicons/xmg.svg": "ee99",
	"./cryptoicons/xmo.svg": "89a8",
	"./cryptoicons/xmr.svg": "f231",
	"./cryptoicons/xmy.svg": "0ccc",
	"./cryptoicons/xno.svg": "172b",
	"./cryptoicons/xof.svg": "a282",
	"./cryptoicons/xp.svg": "bef0",
	"./cryptoicons/xpa.svg": "ea00",
	"./cryptoicons/xpla.svg": "1c6f",
	"./cryptoicons/xpm.svg": "140f",
	"./cryptoicons/xpr.svg": "6573",
	"./cryptoicons/xprt.svg": "47ca",
	"./cryptoicons/xrd.svg": "8ba3",
	"./cryptoicons/xrp.svg": "a8f1",
	"./cryptoicons/xrpbear.svg": "2a92",
	"./cryptoicons/xrpbull.svg": "f5cb",
	"./cryptoicons/xrpdown.svg": "d920",
	"./cryptoicons/xrpup.svg": "ded9",
	"./cryptoicons/xsg.svg": "f17d",
	"./cryptoicons/xtz.svg": "1820",
	"./cryptoicons/xtzdown.svg": "6c1e",
	"./cryptoicons/xtzup.svg": "a47e",
	"./cryptoicons/xuc.svg": "1f43",
	"./cryptoicons/xvc.svg": "2a9d",
	"./cryptoicons/xvg.svg": "1ae0",
	"./cryptoicons/xvs.svg": "9db6",
	"./cryptoicons/xym.svg": "1319",
	"./cryptoicons/xyo.svg": "4f9e",
	"./cryptoicons/xzc.svg": "3d9c",
	"./cryptoicons/yfi.svg": "67e6",
	"./cryptoicons/yfidown.svg": "72ed",
	"./cryptoicons/yfii.svg": "c7b8",
	"./cryptoicons/yfiup.svg": "463f",
	"./cryptoicons/ygg.svg": "191f",
	"./cryptoicons/yld.svg": "106f",
	"./cryptoicons/yooshi.svg": "c91f",
	"./cryptoicons/yoyo.svg": "44f5",
	"./cryptoicons/yoyow.svg": "8355",
	"./cryptoicons/zar.svg": "48ac",
	"./cryptoicons/zbc.svg": "8b41",
	"./cryptoicons/zbu.svg": "062e",
	"./cryptoicons/zcl.svg": "c3a5",
	"./cryptoicons/zcx.svg": "a75b",
	"./cryptoicons/zec.svg": "1acc",
	"./cryptoicons/zel.svg": "4d8a",
	"./cryptoicons/zen.svg": "3fce",
	"./cryptoicons/zest.svg": "e891",
	"./cryptoicons/zeta.svg": "e1bf",
	"./cryptoicons/zig.svg": "03ca",
	"./cryptoicons/zil.svg": "b182",
	"./cryptoicons/zilla.svg": "53bf",
	"./cryptoicons/zrx.svg": "d3ee",
	"./earnPlacements/Binance.svg": "7449",
	"./earnPlacements/Gateio.svg": "07a7",
	"./earnPlacements/Huobi.svg": "f457",
	"./earnPlacements/OKEx.svg": "4dc4",
	"./exchanges/1inch.svg": "2a93",
	"./exchanges/aave.svg": "4c9d",
	"./exchanges/aggregated.svg": "d48c",
	"./exchanges/binance.svg": "11b1",
	"./exchanges/binancefutures.svg": "dab4",
	"./exchanges/bitfinex.svg": "8766",
	"./exchanges/bitmex.svg": "284e",
	"./exchanges/bittrex.svg": "5da4",
	"./exchanges/bnb.svg": "50aa",
	"./exchanges/bybit.svg": "f904",
	"./exchanges/bybit_dark.svg": "f132",
	"./exchanges/compound.svg": "a043",
	"./exchanges/curve.svg": "0a80",
	"./exchanges/ftx.svg": "d691",
	"./exchanges/gateio.svg": "702d",
	"./exchanges/gemini.svg": "7715",
	"./exchanges/hitbtc.svg": "f4f6",
	"./exchanges/huobi.svg": "bb03",
	"./exchanges/huobi_dark.svg": "89e5",
	"./exchanges/huobifutures.svg": "1e59",
	"./exchanges/kraken.svg": "e127",
	"./exchanges/kucoin.svg": "e3f5",
	"./exchanges/liquid.svg": "9915",
	"./exchanges/okex.svg": "d1c9",
	"./exchanges/okex_dark.svg": "7af7",
	"./exchanges/optimism.svg": "b001",
	"./exchanges/otcmarket.svg": "5246",
	"./exchanges/pancakeswap.svg": "666e",
	"./exchanges/polygon.svg": "8151",
	"./exchanges/singlebroker.svg": "689c",
	"./exchanges/singlebroker_dark.svg": "8ea5",
	"./exchanges/sushiswap.svg": "d0b2",
	"./exchanges/uniswap.svg": "8719",
	"./pages/dark/defi.svg": "4328",
	"./pages/dark/earn.svg": "65d1",
	"./pages/dark/portfolios.svg": "86b5",
	"./pages/dark/statement.svg": "ff1b",
	"./pages/dark/terminal.svg": "b103",
	"./pages/dark/wallets.svg": "22ed",
	"./pages/dark/workspace.svg": "9e21",
	"./pages/light/defi.svg": "f485",
	"./pages/light/earn.svg": "e30e",
	"./pages/light/portfolios.svg": "2de8",
	"./pages/light/statement.svg": "5305",
	"./pages/light/terminal.svg": "336e",
	"./pages/light/wallets.svg": "2ad9",
	"./pages/light/workspace.svg": "c5b6",
	"./workspaces/dark/AggregatedBalances.svg": "3191",
	"./workspaces/dark/AssetTrades.svg": "f2d0",
	"./workspaces/dark/BalanceByDay.svg": "2a5d",
	"./workspaces/dark/CurrentAllocation.svg": "5159",
	"./workspaces/dark/CurrentBalance.svg": "48cf",
	"./workspaces/dark/ExchangeTrades.svg": "c86e",
	"./workspaces/dark/OrderBook.svg": "ec86",
	"./workspaces/dark/OrderHistory.svg": "e6c2",
	"./workspaces/dark/Payment.svg": "b61e",
	"./workspaces/dark/PlaceOrder.svg": "f8b80",
	"./workspaces/dark/PnlHistory.svg": "560b",
	"./workspaces/dark/PriceChart.svg": "4ef3",
	"./workspaces/dark/QuickBalances.svg": "98c3",
	"./workspaces/dark/SimpleAggregatedBalances.svg": "c7ff",
	"./workspaces/dark/TradeHistory.svg": "593d",
	"./workspaces/dark/Transfer.svg": "1615",
	"./workspaces/dark/TransferHistory.svg": "6c54",
	"./workspaces/light/AggregatedBalances.svg": "aa76",
	"./workspaces/light/AssetTrades.svg": "1a41",
	"./workspaces/light/BalanceByDay.svg": "fb3f",
	"./workspaces/light/CurrentAllocation.svg": "aaf7",
	"./workspaces/light/CurrentBalance.svg": "117d",
	"./workspaces/light/ExchangeTrades.svg": "441a",
	"./workspaces/light/OrderBook.svg": "1641",
	"./workspaces/light/OrderHistory.svg": "2419",
	"./workspaces/light/Payment.svg": "4a05",
	"./workspaces/light/PlaceOrder.svg": "dc49",
	"./workspaces/light/PnlHistory.svg": "5693",
	"./workspaces/light/PriceChart.svg": "500b",
	"./workspaces/light/QuickBalances.svg": "7ee6",
	"./workspaces/light/SimpleAggregatedBalances.svg": "8703",
	"./workspaces/light/TradeHistory.svg": "2166",
	"./workspaces/light/Transfer.svg": "1c2d",
	"./workspaces/light/TransferHistory.svg": "dde7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d26";